<template>
  <div>
    <div v-if="lead.carrierId" class="callout callout-danger mb-3">
      You are editing an order that has been dispatched! Making significant changes to the dispatch sheet without approval of the Carrier will invalidate your contract.
    </div>    
    <ValidationObserver ref="observer">
      <form @submit.prevent="submit()">
        <FormFieldsLead
          :form-fields="lead"
          :errors="errors"
          @input="updateLocalStateLead"
          render-pricing-form
          render-pickup-contact-form
          render-delivery-contact-form
          render-shipping-form
          :show-customer-search="true"
        />
        <button :disabled="submitDisabled" class="btn btn-primary" type="submit" v-if="!lead.deletedAt">Save</button>
      </form>
    </ValidationObserver>
    <div style="margin-top: 20px;">
    <b-tabs class="nav-tabs-top mb-4">
      <b-tab title="Notes" active>
        <div class="card-body">
         <NotesList v-if="lead && lead.id" :leadlike-id="lead.id" :read-only="false" />
        </div>
      </b-tab>
      <b-tab title="Tasks" lazy ref="tasksTab">
        <div class="card-body">
          <TasksList
            :leadlike-id="lead.id"
            @tasksDue="
              x => {
                lead.tasksDue = x;
              }
            "
          />
        </div>
      </b-tab>
      <b-tab title="Emails" lazy>
        <div class="card-body">
          <EmailsList :leadlike-id="lead.id" />
        </div>
      </b-tab>
      <b-tab title="SMS" lazy>
        <div class="card-body">
          <SmsList :leadlike-id="lead.id" />
        </div>
      </b-tab>
       <b-tab  title="Recordings" lazy>
        <div class="card-body">
          <RecordingsList v-if="lead.userId === user.id || tokenCan('admin')" :leadlike-id="lead.id" />
          <div v-else class="alert alert-info mb-0">You don't have permission to view recordings.</div>
        </div>
      </b-tab>
    </b-tabs>
    </div>
  </div>
</template>

<script>
import FormFieldsLead from '@/components/shared/formFields/FormFieldsLead';
import { ApiClient } from '@/api/ApiClient';
import NotesList from '@/components/shared/NotesList';
import EmailsList from '@/components/shared/EmailsList';
import SmsList from '@/components/shared/SmsList';
import TasksList from '@/components/shared/TasksList';
import RecordingsList from '@/components/shared/RecordingsList';
import permissionsMixin from '/src/mixins/permissions';



export default {
  name: 'LeadlikeEdit',
  mixins: [permissionsMixin],
  data() {
    return {
      lead: {},
      errors: {},
      submitDisabled: false,
      allowLeave: false,
    };
  },
  props: {
    initialLeadQuoteOrder: {
      type: Object,
      required: true,
    },
    leadlikeType: {
      type: String,
      default: 'Order',
    },
  },
  components: { 
        FormFieldsLead,
        NotesList,
        EmailsList,
        SmsList,
        TasksList,
        RecordingsList,
   },
  computed: {
    isQuote() {
      return this.lead.leadTypeId == 2;
    },
    isOrder() {
      return this.lead.leadTypeId == 3;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.updateLeadOnApi();
      } else {
        this.handleSendErrorToast({ message: 'Required field(s) missing.' });
      }
    },
    async updateLeadOnApi() {
      const requestLeadParams = this.lead;
      if (this.submitDisabled) return;
      this.submitDisabled = true;
      const response = await ApiClient.leads.put({ id: this.lead.id, body: requestLeadParams });
      this.submitDisabled = false;
      if (response.status === 200) {
        this.errors = {};
        const updatedLead = response.data.data;
        this.$emit('save', updatedLead);
        this.allowLeave = true;
        if (this.isQuote) {
          this.$router.push({ name: 'QuoteDetails', params: { id: this.lead.id } });
        } else if (this.isOrder) {
          this.$router.push({ name: 'OrderDetails', params: { id: this.lead.id } });
        }
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      }
    },
    updateLocalStateLead(lead) {
      this.lead = lead;
    },
    handleSendErrorToast({ message }) {
      this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
      });
    },
  },
  async mounted() {
    this.lead = this.initialLeadQuoteOrder;
  },
  beforeRouteLeave(to, from, next) {
    if (JSON.stringify(this.initialLeadQuoteOrder) !== JSON.stringify(this.lead) && !this.allowLeave) {
      const answer = window.confirm('Do you really want to leave? There might be unsaved changes!');
      if (!answer) return false;
    }
    next();
  },
 
};
</script>
